// extracted by mini-css-extract-plugin
module.exports = {"title":"Signin_title__3YM-X"};